import { Dialog, styled } from "@mui/material";

export const BaseDropDownWrapper = styled(Dialog)(() => {
    return {
        "& ul": {
            listStyleType: "none",
            paddingInline: 0,
            marginBlock: 0,
        },
        "& li": {
            gap: "calc(var(--flex-gap)/2)",
            "&:hover": {
                backgroundColor: "#791377",
                "& h6": {
                    color: "#FFFFFF"
                },
                "& svg>path": {
                    stroke: "#FFFFFF"
                },
            }
        }
    }
})